import { FC, ReactElement } from "react";
import styled from "@emotion/styled";
import { ErrorColor, SuccessColor } from "@/constants/colors";

import AlertIcon from "../../assets/icons/alert.svg?react";
import SuccessIcon from "../../assets/icons/success.svg?react";

export enum LoginMessageVariant {
    Success,
    Error
}

interface LoginMessageProps {
    message: string | ReactElement;
    variant: LoginMessageVariant;
}

export const LoginMessage: FC<LoginMessageProps> = ({ message, variant }) => (
    <MessageContainer
        style={{
            backgroundColor: variant === LoginMessageVariant.Success ? SuccessColor : ErrorColor
        }}
    >
        {variant === LoginMessageVariant.Success ? <SuccessIconStyled /> : <AlertIconStyled />}
        <>{message}</>
    </MessageContainer>
);

const StyledIconProps = `
  height: 28px;
  width: 28px;
  flex-shrink: 0;
  margin-right: 8px;
  padding: 4px;
`;

const SuccessIconStyled = styled(SuccessIcon)`
    ${StyledIconProps}
`;

const AlertIconStyled = styled(AlertIcon)`
    ${StyledIconProps}
`;

const MessageContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    border-radius: 2px;

    padding: 8px 12px;

    font-size: 16px;

    color: white;
`;
